import { render, staticRenderFns } from "./steam-result.vue?vue&type=template&id=aff27250&scoped=true&"
import script from "./steam-result.vue?vue&type=script&lang=js&"
export * from "./steam-result.vue?vue&type=script&lang=js&"
import style0 from "./steam-result.vue?vue&type=style&index=0&id=aff27250&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff27250",
  null
  
)

export default component.exports